import Vue from 'vue'

import { Settings } from 'luxon'
Settings.defaultLocale = 'pt'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(fas)
library.add(far)
library.add(fab)
Vue.component('icon', FontAwesomeIcon)

import { ModalPlugin } from 'bootstrap-vue'
Vue.use(ModalPlugin)

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

import { Navigation, Pagination } from 'swiper'
import { SwiperCore } from 'swiper-vue2'
SwiperCore.use([Navigation, Pagination])
import 'swiper/swiper-bundle.css'
